// extracted by mini-css-extract-plugin
export default {"container":"cEcoYVfLT","innerContainer":"cEGZEQrMP","colTitle":"c1aVPOIVp","taa":"cDoP0NzNE"};